<div class="select-customer-heading">
  <span class="select-customer-title title-medium-emphasized">{{ 'receipts.ui.selezionaCliente' | transloco }}</span>

  @if (isDesktop) {
    <button
      matButton
      type="button"
      class="desktop-filter-trigger"
      [attr.aria-label]="'receipts.ui.mostraONascondiFiltri' | transloco"
      [attr.aria-expanded]="filtersOpen"
      (click)="toggleDesktopFilters()"
    >
      <i class="fa-regular fa-filter" aria-hidden="true"></i>
      <span class="label-large">{{ 'receipts.ui.filtri' | transloco }}</span>
    </button>
  }
</div>

<mat-form-field
  appearance="outline"
  class="customer-search-field"
  subscriptSizing="dynamic"
  [formGroup]="filtersForm"
>
  <input matInput [placeholder]="'receipts.ui.cercaPerRagSocPIvaCapLocalita' | transloco" formControlName="searchText">
</mat-form-field>

@if (isDesktop && filtersOpen) {
  <mat-card class="desktop-filters-card" [formGroup]="filtersForm">
    <mat-card-content class="desktop-filters-content">
      <mat-form-field appearance="outline" class="filter-field" subscriptSizing="dynamic">
        <mat-label>{{ 'receipts.ui.tipoZona' | transloco }}</mat-label>
        <input matInput formControlName="tipoZona" [matAutocomplete]="autoTipoZona" [placeholder]="'receipts.ui.tutti' | transloco">
        <span matSuffix class="autocomplete-suffix">
          @if (filtersForm.get('tipoZona')?.value?.length) {
            <button mat-icon-button type="button" [attr.aria-label]="'receipts.ui.svuotaTipoZona' | transloco" class="clear-suffix-button" (click)="clearFilterField('tipoZona')">
              <i class="fa-regular fa-xmark"></i>
            </button>
          } @else {
            <i class="fa-regular fa-chevron-down icon-suffix"></i>
          }
        </span>
        <mat-autocomplete #autoTipoZona="matAutocomplete">
          @for (option of filteredTipoZona | async; track option) {
            <mat-option [value]="option">{{ option }}</mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>

      <mat-form-field appearance="outline" class="filter-field" subscriptSizing="dynamic">
        <mat-label>{{ 'receipts.ui.zona' | transloco }}</mat-label>
        <input matInput formControlName="zona" [matAutocomplete]="autoZona" [placeholder]="'receipts.ui.zona' | transloco">
        <span matSuffix class="autocomplete-suffix">
          @if (filtersForm.get('zona')?.value) {
            <button mat-icon-button type="button" [attr.aria-label]="'receipts.ui.svuotaZona' | transloco" class="clear-suffix-button" (click)="clearFilterField('zona')">
              <i class="fa-regular fa-xmark"></i>
            </button>
          } @else {
            <i class="fa-regular fa-chevron-down icon-suffix"></i>
          }
        </span>
        <mat-autocomplete #autoZona="matAutocomplete" (optionSelected)="onZonaSelected($event.option.value)">
          @for (option of filteredZona | async; track option.id) {
            <mat-option [value]="option">{{ option.nome }}</mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>

      <mat-form-field appearance="outline" class="filter-field" subscriptSizing="dynamic">
        <mat-label>{{ 'receipts.ui.dataUltimaFattura' | transloco }}</mat-label>
        <input matInput [matDatepicker]="picker" formControlName="dataUltimaFattura" [placeholder]="'receipts.ui.datePlaceholder' | transloco">
        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>

      @if (filterOptions.agente.length) {
        <mat-form-field appearance="outline" class="filter-field" subscriptSizing="dynamic">
          <mat-label>{{ 'receipts.ui.agente' | transloco }}</mat-label>
          <input matInput formControlName="agente" [matAutocomplete]="autoAgente" [placeholder]="'receipts.ui.tutti' | transloco">
          <span matSuffix class="autocomplete-suffix">
            @if (filtersForm.get('agente')?.value) {
              <button mat-icon-button type="button" [attr.aria-label]="'receipts.ui.svuotaAgente' | transloco" class="clear-suffix-button" (click)="clearFilterField('agente')">
                <i class="fa-regular fa-xmark"></i>
              </button>
            } @else {
              <i class="fa-regular fa-chevron-down icon-suffix"></i>
            }
          </span>
          <mat-autocomplete #autoAgente="matAutocomplete" (optionSelected)="onAgenteSelected($event.option.value)">
            @for (option of filteredAgente | async; track option.value) {
              <mat-option [value]="option">{{ option.label }}</mat-option>
            }
          </mat-autocomplete>
        </mat-form-field>
      }

      @if (filterOptions.ispettore.length) {
        <mat-form-field appearance="outline" class="filter-field" subscriptSizing="dynamic">
          <mat-label>{{ 'receipts.ui.ispettore' | transloco }}</mat-label>
          <input matInput formControlName="ispettore" [matAutocomplete]="autoIspettore" [placeholder]="'receipts.ui.tutti' | transloco">
          <span matSuffix class="autocomplete-suffix">
            @if (filtersForm.get('ispettore')?.value) {
              <button mat-icon-button type="button" [attr.aria-label]="'receipts.ui.svuotaIspettore' | transloco" class="clear-suffix-button" (click)="clearFilterField('ispettore')">
                <i class="fa-regular fa-xmark"></i>
              </button>
            } @else {
              <i class="fa-regular fa-chevron-down icon-suffix"></i>
            }
          </span>
          <mat-autocomplete #autoIspettore="matAutocomplete" (optionSelected)="onIspettoreSelected($event.option.value)">
            @for (option of filteredIspettore | async; track option.value) {
              <mat-option [value]="option">{{ option.label }}</mat-option>
            }
          </mat-autocomplete>
        </mat-form-field>
      }

      <mat-checkbox class="new-customer-filter" formControlName="newCustomer">{{ 'receipts.ui.clienteNuovo' | transloco }}</mat-checkbox>
    </mat-card-content>

    <mat-card-actions align="end">
      <button matButton type="button" (click)="resetFilters()">{{ 'receipts.ui.cancella' | transloco }}</button>
      <button matButton="filled" type="button" (click)="applyFilters()">{{ 'receipts.ui.applica' | transloco }}</button>
    </mat-card-actions>
  </mat-card>
}

@if (isInitialLoading) {
  <div class="customers-initial-loading">
    <ui-loading-spinner />
  </div>
}

@if (customersEmpty) {
  <div class="customers-empty-state">
    <span class="body-medium">{{ 'receipts.ui.nessunElementoTrovato' | transloco }}</span>
  </div>
}

<div class="mobile-customers-list">
  @for (customer of customers; track customer.idBusinessPartner) {
    <button
      type="button"
      class="customer-row"
      [attr.aria-label]="(('receipts.ui.seleziona' | transloco) + ' ') + customer.ragioneSociale"
      (click)="selectCustomer(customer)"
    >
      <div class="customer-info">
        <span class="body-medium-emphasized">{{ customer.ragioneSociale }}</span>

        <span class="customer-subtitle body-small">
          <i
            [attr.class]="'fa-solid ' + getCustomerAlertIcon(customer.alert?.stato) + ' customer-alert-icon ' + getCustomerAlertClass(customer.alert?.stato)"
            aria-hidden="true"
          ></i>
          <span>{{ customer.nomeZona }} - {{ customer.nomeAgente }}</span>
        </span>

        <div class="customer-financial-summary">
          <mat-chip
            disabled
            selected
            [class]="getCustomerPriceListClass(customer.tipoListino)"
          >
            {{ getCustomerPriceListLabel(customer.tipoListino) }}
          </mat-chip>

          <span class="customer-exposure body-medium">
            {{ 'receipts.ui.esposizione' | transloco }}
            <span
              class="body-medium-emphasized"
              [class.customer-exposure-success]="customer.esposizione >= 0"
              [class.customer-exposure-error]="customer.esposizione < 0"
            >
              {{ customer.esposizione | translocoCurrency: 'symbol' : {
                useGrouping: true,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              } : 'EUR' }}
            </span>
          </span>
        </div>
      </div>

      <span class="customer-chevron" aria-hidden="true">
        <i class="fa-regular fa-chevron-right"></i>
      </span>
    </button>
  }

  @if (isLoadingMore) {
    <div class="customers-load-more">
      <ui-loading-spinner />
    </div>
  }

  <div #loadMoreTrigger class="load-more-trigger" aria-hidden="true"></div>
</div>

@if (isDesktop) {
  @if (desktopCustomersLoading) {
    <div class="desktop-customers-loading">
      <ui-loading-spinner />
    </div>
  } @else if (desktopCustomersEmpty) {
    <div class="desktop-customers-empty-state">
      <span class="body-medium">{{ 'receipts.ui.nessunElementoTrovato' | transloco }}</span>
    </div>
  } @else {
    <ui-table-view
      class="desktop-customers-table"
      [columnsInfo]="columnsInfo"
      [data]="desktopCustomers"
      [sortColumns]="currentSortColumns"
      (sortChange)="onDesktopSortChange($event)"
      (rowClicked)="selectCustomer($event)"
      (reloadData)="loadDesktopCustomers()"
    />

    <mat-paginator
      class="desktop-customers-paginator"
      [length]="desktopTotalItems"
      [pageSize]="desktopPageSize"
      [pageIndex]="desktopPageIndex"
      [pageSizeOptions]="[5, 10, 25]"
      [hidePageSize]="true"
      (page)="onDesktopPageChange($event)"
    />
  }
}
